import { AutogenModelInformationPacket, AutogenRowInformationPacket } from "./autogen/AutogenModelInformationPacket";

export class ModelInformationPacket extends AutogenModelInformationPacket<RowInformationPacket> {
	constructor() {
		super(RowInformationPacket);
	}
}

export class RowInformationPacket extends AutogenRowInformationPacket {
}